import styled from 'styled-components';

import { style } from '@genially/design-system';

interface ColumnScrollAreaProps {
  $isBlurred?: boolean;
}

/** The scroll box of a full-screen column: the two lists scroll without moving the rest. */
export const ColumnScrollArea = styled.div<ColumnScrollAreaProps>(
  ({ theme, $isBlurred }) => ({
    flex: 1,
    ...(!$isBlurred && { overflowY: 'auto' }),

    ...style.mixins.scrollbar(theme, true),
  }),
);
